export default __webpack_public_path__ + "media/images/mailer-new/welcome/step1-on-57e31b0ecbae9c347703c49fc0fa1073.png";